import { useState, useCallback } from 'react';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { conf } from '../../../confg';
import { errorAction } from '../../../actions/request_error';
export const useCheckout = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [confirmed, setConfirmed] = useState(false);
  const goldGramCartUsage = useSelector((state) => state.cart.gold_gram_cart_usage) || 0;

  const performFinalCheck = useCallback(
    async (addressId, shippingMethodId) => {
      setLoading(true);

      const payload = {
        address_id: addressId,
        shipping_method_id: shippingMethodId,
      };

      payload.use_gold_gram_wallet = goldGramCartUsage > 0;

      try {
        await axios({
          url: conf.server_url + 'checkpay',
          method: 'POST',
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
          },
          data: payload,
        });

        setConfirmed(true);
        return { success: true };
      } catch (err) {
        const response = err.response?.data;

        const errorMessages = {
          date: 'زمان و ارسال اشتباه است',
          address: 'آدرس ارسال اشتباه است',
          shipping: 'روش ارسال انتخاب نشده است',
          account: 'ساخت اکانت در حسابداری با خطا مواجه شده با ادمین تماس بگیرید',
          default: 'با ادمین تماس بگیرید خطایی پیش امده است یا مجدد لاگین کنید',
        };

        const errorMessage = errorMessages[response?.on] || errorMessages.default;
        dispatch(errorAction(errorMessage));

        return { success: false, error: errorMessage };
      } finally {
        setLoading(false);
      }
    },
    [dispatch, goldGramCartUsage],
  );

  const handlePreOrder = useCallback((addressId, shippingMethodId, timeIndex, date, preOrderId) => {
    const params = new URLSearchParams({
      address_id: addressId,
      shipping_method_id: shippingMethodId,
      time_index: timeIndex,
      date: date,
      per_pay_id: preOrderId,
      jwt: localStorage.getItem('token'),
    });

    window.location = `${conf.server_url}perbuy/final/pay?${params.toString()}`;
  }, []);

  const reset = useCallback(() => {
    setConfirmed(false);
    setLoading(false);
  }, []);

  return {
    loading,
    confirmed,
    performFinalCheck,
    handlePreOrder,
    reset,
  };
};
